module.exports = __webpack_public_path__ + "book_right-427878af7eaa23c9170ec03128f375df.png";